export default __webpack_public_path__ + "static/media/birfcase.ed382fd2.svg";